import React from 'react';
import styled from 'styled-components';

const Inventory = styled.span`
  color: #798794;
`;

export function InventoryQty({
  inventoryQuantity,
}: {
  inventoryQuantity: string;
}) {
  if (Number.isNaN(parseInt(inventoryQuantity, 10))) {
    inventoryQuantity = `0`;
  }
  return <Inventory>({inventoryQuantity} items)</Inventory>;
}
